import { render, staticRenderFns } from "./DayanakList.vue?vue&type=template&id=35879ad5&scoped=true"
import script from "./DayanakList.vue?vue&type=script&lang=ts"
export * from "./DayanakList.vue?vue&type=script&lang=ts"
import style0 from "./DayanakList.vue?vue&type=style&index=0&id=35879ad5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35879ad5",
  null
  
)

export default component.exports